import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

function App() {
  const [searchParams] = useSearchParams();
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
    const params = Object.fromEntries([...searchParams]);
    if (Object.keys(params).length === 0) return;

    const request = {
      appointmentId: params.appointmentId,
      appointmentConfirmed: params.appointmentConfirmed === "si",
    };

    const submitData = async () => {
      setLoading(true);
      try {
        const response = await fetch("https://production.moons.ninja/kustomer/update-appointment-info", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(request),
        });

        if (response.ok) {
          setSubmitted(true);
          setHasError(false);
        } else {
          setHasError(true);
        }
      } catch (err) {
        setHasError(true);
        console.error("Excepción:", err);
      } finally {
        setLoading(false);
      }
    };

    submitData();
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-100">
      {loading ? (
        <div className="flex flex-col items-center text-gray-700 text-lg sm:text-xl font-semibold">
          <div className="w-12 h-12 sm:w-16 sm:h-16 border-4 border-gray-300 border-t-transparent rounded-full animate-spin mb-4"></div>
          Enviando tus respuestas...
        </div>
      ) : hasError ? (
        <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 max-w-sm w-full text-center border border-red-300">
          <h1 className="text-xl sm:text-2xl font-bold text-red-600">
            Ocurrió un error
          </h1>
          <p className="text-gray-700 mt-4 text-sm sm:text-base">
            No pudimos procesar tu respuesta. Por favor intenta de nuevo más tarde.
          </p>
        </div>
      ) : submitted ? (
        <div className="bg-white rounded-2xl shadow-xl p-4 sm:p-6 md:p-8 max-w-sm w-full text-center">
          <h1 className="text-xl sm:text-2xl font-bold text-rose-600">
            ¡Gracias por tu respuesta!
          </h1>
          <p className="text-gray-700 mt-4 text-sm sm:text-base">
            Hemos recibido tu información correctamente.
          </p>
        </div>
      ) : (
        <div className="text-lg sm:text-xl font-semibold text-center text-gray-800">
          Esperando parámetros en la URL...
        </div>
      )}
    </div>
  );
}

export default App;
